import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import { ref } from 'vue';
dayjs.extend(duration)

const now = ref(dayjs(new Date()))
export function subs_time(start_date, sub_duration){
  let time = 'Error'
  let temp_start_date = dayjs(start_date)
  let end_date = temp_start_date.add(sub_duration, 'day')
  let temp = end_date.diff(now.value)
  if (temp < 0){
    return time = "Expired"
  }
  let diff = dayjs.duration(end_date.diff(now.value))
  let months = diff.months();
  let days = diff.days();
  let hours = diff.hours();
  let minutes = diff.minutes();
  let parts = [];
  if (months > 0) parts.push(`${months} months`);
  if (days > 0) parts.push(`${days} days`);
  if (hours > 0) parts.push(`${hours} hours`);
  if (minutes > 0) parts.push(`${minutes} minutes`);
  
  time = parts.length > 0 ? parts.join(' ') : 'Less than a minute';
  return time
}

export const formattedDate = (date, needTime = false) => {
  if (needTime){
    return dayjs(date).format('H:m, DD MMM YYYY')
  }
  return dayjs(date).format('DD MMM YYYY')
}

export const humanizeText = (text) => {
  if (!text) return 'N/A';
  if (text == 'system_feedback'){
    return "System Feedback Ticket"
  }
  const words = text.split('_');
  const humanizedText = words
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');

  return humanizedText;
}

export const setStatusColor = (status) => {
  switch (status) {
    case "processing":
      return "badge-light-warning"
    case "reviewing":
      return "badge-light-primary"
    case "verified":
      return "badge-light-success"
    default:
      return "badge-light-light disabled"
  }
}

export const parse_meta_key = (items)=>{
  let x = items.reduce((acc, obj) => {
    acc[obj.attributes.key] = obj.attributes.value;
    return acc;
  }, {});
  return x
}

export const swalError = (errorInfo, isHtml = false) => {
  let text = errorInfo;
  let requestId = null;

  // Handle structured error object from utils/errorHandler
  if (typeof errorInfo === 'object' && errorInfo !== null) {
    text = errorInfo.message || errorInfo.result || 'An unknown error occurred';
    requestId = errorInfo.requestId;
    
    // If it's a validation error object
    if (errorInfo.error && errorInfo.result) {
      if (typeof errorInfo.result === 'string') {
        text = errorInfo.result;
      }
    }
  }

  const footer = requestId ? `Support ID: <code>${requestId}</code>` : null;

  if (isHtml) {
    Swal.fire({
      title: 'Error',
      html: parseError(text),
      icon: 'error',
      footer: footer
    });
  } else {
    Swal.fire({
      title: 'Error',
      text: typeof text === 'string' ? text : 'An error occurred',
      icon: 'error',
      footer: footer
    });
  }
}

// Duplicate swalSuccess removed

export const swalSuccess = (text, isHtml = false) =>{
  if (isHtml){
    Swal.fire({title: 'Success', html: text, icon: 'success'})
  }else{
    Swal.fire({title: 'Success', text, icon: 'success'})
  }
}

export const getLowerAge = (label) => {
  const match = label.match(/(\d+)\s*yrs/);
  return match ? parseInt(match[1], 10) : 0;
}

export const sortAgeGroup = (terms)=>{
  terms.sort((a, b) => getLowerAge(a.label) - getLowerAge(b.label));
  return terms
}

export const create_chart_label = (list)=>{
  let labels = ['Baseline']
  let increment = 4
  let current = 0
  // list.pop() // bug
  let shit = [...list]
  shit.pop()
  shit.forEach(x => {
    current += increment
    labels.push(`${current}th`)
  });
  return labels
}

export const getAgeFromRange = (dob, from) =>{
  let today = new Date(from);
  let birthDate = new Date(dob);
  let age = today.getFullYear() - birthDate.getFullYear();
  let m = today.getMonth() - birthDate.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
  }
  return age;
}

function hexToRgb(hex) {
  hex = hex.replace('#', '');
  let bigint = parseInt(hex, 16);
  let r = (bigint >> 16) & 255;
  let g = (bigint >> 8) & 255;
  let b = bigint & 255;
  return [r, g, b];
}

function rgbToHex(r, g, b) {
  return "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
}

function interpolateColor(color1, color2, factor) {
  let result = color1.slice();
  for (let i = 0; i < 3; i++) {
      result[i] = Math.round(result[i] + factor * (color2[i] - color1[i]));
  }
  return result;
}

export function generateGradient(mainColorHex, endColorHex, steps) {
  let mainColor = hexToRgb(mainColorHex);
  let endColor = hexToRgb(endColorHex);
  let gradient = [];
  for (let i = 0; i <= steps; i++) {
      let factor = i / steps;
      let interpolatedColor = interpolateColor(mainColor, endColor, factor);
      gradient.push(rgbToHex(...interpolatedColor));
  }
  return gradient;
}

export function parse_notification_response(response, included){
  let tempNotifications = response.map(notification => {
    let entity_type = included
                      .filter(item => item.type == 'entity_type')
                      .find(item => item.id == notification.attributes.entity_type_id)
    let actor = included
                      .filter(item => item.type == 'user')
                      .find(item => item.id == notification.attributes.actor_id)
    let meta = parse_meta_key(included.filter(item => item.type == 'notification_metum' && item.attributes.notification_id == notification.id))
    meta = {
      ...meta, 
      account_name: actor.attributes.first_name + ' ' + actor.attributes.first_name
    }
    return {
      ...notification,
      entity_type,
      meta
    }
  })
  return tempNotifications
}

export function parse_notification_description(notification){
  let { description } = notification.entity_type.attributes;
  const meta = notification.meta;
  meta.account_name = notification.meta.name

  // Replace placeholders in the description
  Object.keys(meta).forEach(key => {
    const placeholder = `$${key}`;
    description = description.replace(placeholder, meta[key]);
  });
  return description
}

export const getAge = (dob) =>{
  let today = new Date();
  let birthDate = new Date(dob);
  let age = today.getFullYear() - birthDate.getFullYear();
  let m = today.getMonth() - birthDate.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }
  let displayAge = ''
  if (age < 1){ // if age 0
    let nowJs = dayjs(new Date())
    let dobJs = dayjs(new Date(dob))
    let diff = dayjs.duration(nowJs.diff(dobJs))
    let month = diff.months()
    age = month/12
    age = Math.round(age * 100) / 100
    switch (age) {
      case 0.08:
        displayAge = '1 months'
        break;
      case 0.17:
        displayAge = '2 months'
        break;
      case 0.25:
        displayAge = '3 months'
        break;
      case 0.33:
        displayAge = '4 months'
        break;
      case 0.42:
        displayAge = '5 months'
        break;
      case 0.50:
        displayAge = '6 months'
        break;
      case 0.58:
        displayAge = '7 months'
        break;
      case 0.67:
        displayAge = '8 months'
        break;
      case 0.75:
        displayAge = '9 months'
        break;
      case 0.83:
        displayAge = '10 months'
        break;
      case 0.92:
        displayAge = '11 months'
        break;
      case 1:
        displayAge = '1'
        break;
      default:
        break;
    }
  }
  if (displayAge == '') return age + ' years old'
  return displayAge
}

export const numberWithCommas = (value) =>{
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export const parseError = (response) =>{
  if (typeof response === 'string') {
    // Create a temporary element to parse the HTML
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = response;

    // Check if HTML was parsed correctly by comparing innerHTML
    const h1 = tempDiv.querySelector("h1");
    return h1 ? h1.textContent : "Unknown Server Error";
    // if (tempDiv.innerHTML === htmlString) {
    //   // Extract the first <h1> tag if it exists
    //   return firstH1 ? firstH1.textContent : null; // Return text content or null if not found
    // }
    // return null; // Return null if invalid HTML
  } else if (typeof response === 'object' && response !== null) {
    if (response.error){
      return response.error
    }
    return formatObjectErrors(response)
  } else {
    console.log('Unknown Response Type');
  }
}

function formatObjectErrors(response) {
  if (typeof response === 'object' && response !== null) {
    return Object.entries(response)
      .map(([key, errors]) => `${key} ${errors.join(', ')}`)
      .join('<br/>');
  }
  return '';
}

export const formatCurrency = (amount, currency = 'MYR') => {
  const formatter = new Intl.NumberFormat('en-MY', {
    style: 'currency',
    currency: currency.toUpperCase()
  });
  return formatter.format(amount);
};

export function getInvStatusColor(status) {
  const colors = {
    paid: 'success',
    pending: 'warning',
    overdue: 'danger',
    draft: 'secondary'
  }
  return colors[status] || 'secondary'
}